import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 24 24" width={18} height={18}>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="编组-7">
        <rect id="矩形" x="0" y="0" width="24" height="24"></rect>
        <g id="充值-(41)" transform="translate(3, 2.5)" fill-rule="nonzero">
          <path
            d="M12.1718813,0 L5.78705219,0 C5.78705219,0 4.19137504,0 4.98974373,1.5865 C5.78705219,3.173 7.38378957,3.96677777 8.97840646,3.96677777 C10.5730234,3.96677777 12.170821,3.173 12.9691897,1.5865 C13.7686186,0 12.1718813,0 12.1718813,0"
            id="路径"
            fill="#78787C"
          ></path>
          <path
            d="M11.9184814,12.5220556 L9.64636433,14.7777778 C9.28741094,15.1311327 8.7096915,15.1311327 8.35073811,14.7777778 L6.07968134,12.5220556 C5.72326619,12.1661256 5.72326619,11.5902077 6.07968134,11.2342778 L8.35285862,8.9775 C8.71181201,8.62414508 9.28953145,8.62414508 9.64848484,8.9775 L11.9195416,11.2342778 C12.2759568,11.5902077 12.2759568,12.1661256 11.9195416,12.5220556 M17.7625826,10.2948333 C16.7977546,6.45683333 12.1867248,3.173 12.1867248,3.173 C11.3904766,4.75633333 9.00067173,4.75633333 9.00067173,4.75633333 C9.00067173,4.75633333 6.61086688,4.75633333 5.8146187,3.173 C5.8146187,3.173 1.20464912,6.45577777 0.237700572,10.2958889 C-0.55748736,13.4604444 0.237700572,19 8.99961148,19 C17.7615224,19 18.5588308,13.4604444 17.7615224,10.2958889"
            id="形状"
            fill="currentColor"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default CMP;
